export default function sortStyles(thatStyle, isPubslished, reverse) {
  if (!thatStyle) return;

  const thisArray = Object.keys(thatStyle).filter(function(element) {
    if (element === '0' || element === 0) return;
    return element;
  }).sort(function (prev, next) {
    const prevKey = prev.replace('_', '.');
    const nextKey = next.replace('_', '.');
    return Number.isNaN(parseFloat(prevKey)) ? 0 : parseFloat(nextKey) - parseFloat(prevKey);
  });

  if (isPubslished || reverse) {
    thisArray.push('0');
  } else {
    thisArray.unshift('0');
  }

  return reverse ? thisArray.reverse() : thisArray;
}
